export const unAvailableTutorLoading =  ({store})  => store.unAvailableTutorReducer.loading;

export const unAvailableTutorError =  ({store})  => store.unAvailableTutorReducer.error;

export const unAvailableTutorData =  ({store})  => store.unAvailableTutorReducer.data;